import config from '../../../../application/config/config';
import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';

function LastAccess(props) {   
    const pathFrontEnd = '/core/users/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpoint: config.endpoints.backend + 'core/logs/getall',
    }

    const list = {
        canAdd: false,
        canView: false,
        canEdit: false,
        canDelete: false,
        viewActionColumn: false,
        labelTitle: 'Lista de últimos acessos',
        filter: {
            core_user_id: props.id
        },
        columns: [
            {
                name: 'formatted_date',
                label: 'Data'
            },
            {
                name: 'user_ip',
                label: 'IP do Usuário'
            },
        ],
        ...paths
    };

    return (
        <div>
            <CustomListContainer
                list={list}
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                content={<CustomList list={list} />}
            />
        </div>
    );
}
export default LastAccess;